<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="filterBox flex">
      <div class="box flex">
        <div class="label">提交时间</div>
        <el-date-picker v-model="time1"
                        type="daterange"
                        range-separator="~"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="search"
                        style="width:240px"></el-date-picker>
      </div>
      <div class="box flex">
        <div class="label">医生姓名</div>
        <el-input v-model="doctor_name"
                  style="width: 170px"
                  @input="search" />
      </div>
      <div class="box flex">
        <div class="label">手机号</div>
        <el-input v-model="phone"
                  style="width: 170px"
                  @input="search" />
      </div>
      <div class="box flex">
        <div class="label">投诉类型</div>
        <el-select v-model="complaint_type_id"
                   filterable
                   allow-create
                   style="width: 170px">
          <el-option label="全部"
                     :value="''">
          </el-option>
          <el-option v-for="item in typeList"
                     :key="item.complaint_type_id"
                     :label="item.complaint_title"
                     :value="item.complaint_type_id">
          </el-option>
          <el-option label="其他"
                     :value="0">
          </el-option>
        </el-select>
      </div>
      <div class="box flex">
        <div class="label">回访人</div>
        <el-input v-model="admin_name"
                  style="width: 170px" />
      </div>
      <div class="box flex">
        <div class="label">回访时间</div>
        <el-date-picker v-model="time2"
                        type="daterange"
                        range-separator="~"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="search"
                        style="width:240px"></el-date-picker>
      </div>
      <div class="box flex">
        <span class="label">是否回访</span>
        <span>
          <el-radio-group v-model="is_return"
                          @change="search">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </span>
      </div>
      <div class="box flex">
        <span style="margin-right: 10px">是否满意</span>
        <el-radio-group v-model="is_satisfied"
                        @change="search">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </div>
      <div class="box flex">
        <span style="margin-right: 10px">是否解决</span>
        <el-radio-group v-model="is_solve"
                        @change="search">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
        <el-button type="info"
                   style="background-color: #eceff2; color: #747981;margin-left:20px"
                   @click="search">查询</el-button>
      </div>
    </div>
    <div style="text-align:right;margin-bottom:10px">
      <el-button type="primary"
                 :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('912')
                          : false
                      "
                 @click="addType">投诉类型维护</el-button>
    </div>
    <div style="border: solid 1px #c9cbd6">
      <el-table ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }">
        <el-table-column prop="create_time"
                         label="提交时间" />
        <el-table-column label="医生姓名">
          <template slot-scope="scope">
            <span @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor:pointer">{{scope.row.doctor_name}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="phone"
                         label="手机号" />
        <el-table-column label="投诉类型">
          <template slot-scope="scope">
            <div>{{scope.row.complaint_title}}</div>

            <el-popover placement="right"
                        width="300"
                        trigger="click"
                        :content="scope.row.complaint_desc">
              <div class="complaint_desc"
                   slot="reference">{{scope.row.complaint_desc}}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="是否回访">
          <template slot-scope="scope">
            <div>{{ scope.row.is_return ==1?"是":"否"}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="return_time"
                         label="回访时间" />
        <el-table-column prop="admin_name"
                         label="回访人" />
        <el-table-column label="是否满意">
          <template slot-scope="scope">
            <div v-if="scope.row.is_satisfied ==1">是</div>
            <div v-if="scope.row.is_satisfied ==2">否</div>
          </template>
        </el-table-column>
        <el-table-column label="是否解决">
          <template slot-scope="scope">
            <div v-if="scope.row.is_solve ==1">是</div>
            <div v-if="scope.row.is_solve ==2">否</div>
          </template>
        </el-table-column>
        <el-table-column prop="remark"
                         label="备注" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text"
                       @click="setReturnLog(scope.row)"
                       :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('913')
                          : false
                      ">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="10"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalNum"
                   style="margin:20px 0"></el-pagination>

    <!-- <div class="page_title">医生投诉列表</div>
    <div style="padding: 20px">
      <div class="container">
      </div>
    </div> -->

    <!-- 回访记录 -->
    <el-dialog :title="title"
               :visible.sync="returnLog"
               width="500px"
               style="text-align: left"
               :close-on-click-modal="false"
               center>
      <div class="content">
        <div>
          <span class="label">回访人</span>
          <span>{{username}}</span>
        </div>
        <div v-if="is_return_log"
             style="margin:14px 0">
          <span class="label">回访时间</span>
          <span>{{return_data.return_time}}</span>
        </div>
        <div style="margin:14px 0"
             v-else>
          <span class="label">回访时间</span>
          <el-date-picker v-model="return_data.return_time"
                          type="datetime"
                          placeholder="选择日期时间"
                          format="yyyy-MM-dd HH:mm"
                          value-format="yyyy-MM-dd HH:mm">
          </el-date-picker>
        </div>
        <div>
          <span class="label"
                style="width:140px">医生对回访是否满意</span>
          <el-radio-group v-model="return_data.is_satisfied">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </div>
        <div style="margin:14px 0">
          <span class="label"
                style="width:140px; ">医生问题是否得到解决</span>
          <el-radio-group v-model="return_data.is_solve">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </div>

        <div v-if="is_return_log">
          <div class="label">备注</div>
          <span style="margin-top:5px">{{return_data.remark}}</span>
        </div>
        <div v-else>
          <div class="label">备注</div>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 6}"
                    v-model="return_data.remark"
                    maxlength="500"
                    style="margin-top:5px">
          </el-input>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer"
            v-if="!is_return_log">
        <el-button @click="returnLog = false"
                   plain>取消</el-button>
        <el-button type="primary"
                   @click="saveDoctorComplaintInfo">确 定</el-button>
      </span>
      <span slot="footer"
            class="dialog-footer"
            v-if="is_return_log">
        <el-button type="primary"
                   @click="changeReturnLog">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      typeList: [],
      doctor_name: '',
      phone: '',
      complaint_type_id: '',
      admin_name: '',
      is_return: 0,
      is_satisfied: 0,
      is_solve: 0,
      time1: [],
      time2: [],
      title: '添加回访记录',
      returnLog: false,
      username: this.$store.state.userInfo.userInfo.real_name
        ? this.$store.state.userInfo.userInfo.real_name
        : this.$store.state.userInfo.userInfo.user_name,
      return_data: {
        complaint_id: '',
        return_time: '',
        is_satisfied: 1,
        is_solve: 1,
        return_time: ''
      },
      is_return_log: false,
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
    this.getComplaintTypeList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取投诉类型
    getComplaintTypeList() {
      this.axios
        .post('platform/activity/getDoctorComplaintTypeList')
        .then((res) => {
          this.typeList = res.data.list;
        });
    },
    //获取认证记录列表
    getList() {
      let data = {
        doctor_name: this.doctor_name,
        phone: this.phone,
        complaint_type_id: this.complaint_type_id,
        admin_name: this.admin_name,
        is_return: this.is_return,
        is_satisfied: this.is_satisfied,
        is_solve: this.is_solve,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      if (this.time1 && this.time1.length > 0) {
        data.submit_start_time = dayjs(this.time1[0]).format('YYYY-MM-DD');
        data.submit_end_time = dayjs(this.time1[1]).format('YYYY-MM-DD');
      }
      if (this.time2 && this.time2.length > 0) {
        data.return_start_time = dayjs(this.time2[0]).format('YYYY-MM-DD');
        data.return_end_time = dayjs(this.time2[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/activity/getDoctorComplaintList', data)
        .then((res) => {
          if (!res.data.list.length && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.getList();
          }
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            item.return_time = item.return_time
              ? dayjs.unix(item.return_time).format('YYYY-MM-DD HH:mm')
              : '';
            return item;
          });
          this.totalNum = res.data.total;
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //打开投诉弹窗
    setReturnLog(row) {
      if (row.is_return == 1) {
        this.title = '回访记录';
        this.is_return_log = true;
        this.return_data = {
          complaint_id: row.complaint_id,
          return_time: row.return_time,
          is_satisfied: row.is_satisfied,
          is_solve: row.is_solve,
          remark: row.remark
        };
      } else {
        this.title = '添加回访记录';
        this.is_return_log = false;
        this.return_data = {
          complaint_id: row.complaint_id,
          return_time: dayjs(new Date()).format('YYYY-MM-DD HH:mm'),
          is_satisfied: 1,
          is_solve: 1,
          remark: ''
        };
      }
      this.returnLog = true;
    },
    //提交回访记录
    saveDoctorComplaintInfo() {
      let data = this.return_data;
      this.axios
        .post('platform/activity/saveDoctorComplaintInfo', data)
        .then((res) => {
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.getList();
          this.returnLog = false;
        });
    },
    //修改回访记录
    changeReturnLog() {
      this.title = '修改回访记录';
      this.is_return_log = false;
    },
    //类型维护
    addType() {
      this.$router.push('complaintype');
    }
  }
};
</script>

<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  flex-wrap: wrap;
  align-items: center;
  .box {
    margin-right: 22px;
    margin-bottom: 12px;
    align-items: center;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
.complaint_desc {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.content {
  padding: 20px;

  .label {
    display: inline-block;
    min-width: 80px;
    font-weight: 700;
    font-size: 14px;
    margin-right: 20px;
  }
}
</style>
<style lang="scss">
.el-image > img {
  height: 100px;
  width: auto;
  display: block;
}
.el-image-viewer__close {
  i {
    color: #ffffff;
  }
}
</style>


